// test1061
(1061 && 0);
